import Apis from 'src/assets/js/Apis.js'
import Vue from 'vue'
import { is } from 'quasar'
import enumeration from 'src/assets/js/enumeration'

export default ({ app, store }) => {
    Vue.mixin(Apis)
    Vue.mixin({
        data() {
            return {
                enumeration: {},
                SEO: {},
            }
        },
        created() {
            this.enumeration = enumeration()
            if ((this.$ssrContext && this.$ssrContext.preFetch) || (this.$options && this.$options.preFetch)) {
                if (Object.keys(store.state.asyncData).length) {
                    const defData = { ...this.$data }
                    const asyncData = JSON.parse(JSON.stringify(store.state.asyncData))
                    Object.assign(this.$data, asyncData)
                    Object.keys(asyncData).forEach(item => {
                        if (this.$data[item] && typeof this.$data[item] == 'object') {
                            Object.assign(this.$data[item], this.assignEmpty(defData[item], asyncData[item]))
                        }
                    })
                }
            }
        },
        computed: {
            // 全局挂件参数值
            globalConfig() {
                return this.$store.state.globalConfig
            },
            seoData() {
                return this.$store.state.seoData
            },
            isLogin() {
                return this.$store.state.isLogin
            },
            userInfo() {
                return this.$store.state.userInfo
            },
            userType() {
                return this.$store.state.userInfo?.userType
            },
            /* 返回当前语言环境的计算属性。 */
            locale() {
                return this.$i18n.locale
            },
            huobi() {
                return this.$store.state.huobi
            },
            catCount() {
                return this.$store.state.catCount
            },
        },
        methods: {
            openUrl(url) {
                window.open(url)
            },
            // 拍平树结构
            /**
             * @param {source: array, children: string}
             * @return {arr: array}
             */
            treeFlat(source = [], children = 'childrenList') {
                let res = []
                source.forEach(el => {
                    res.push(el)
                    el[children] && res.push(...this.treeFlat(el[children], children))
                })
                return res
            },
            // 去除el-cascader 最后一级
            getCascader(data, children = 'childrenList') {
                data.forEach(item => {
                    if (item[children]) {
                        if (item[children].length < 1) {
                            // children若为空数组，则将children设为undefined
                            item[children] = undefined
                        } else {
                            // children若不为空数组，则继续 递归调用 本方法
                            this.getCascader(item[children])
                        }
                    }
                })
                return data
            },
            // 获取单位索引
            getUnitIndex(data) {
                if (data) {
                    let priceUnitInfoList = {}
                    if (data.priceUnitInfoList && data.priceUnitInfoList.length) {
                        priceUnitInfoList = data.priceUnitInfoList.find(item => item.defaultPriceUnit == 10) || {}
                    }
                    if (data.priceUnitInfoTransferList && data.priceUnitInfoTransferList.length) {
                        const index = data.priceUnitInfoTransferList.findIndex(
                            item => item.priceUnitCode == priceUnitInfoList.itemId
                        )
                        return index == -1 ? 0 : index
                    } else {
                        return 0
                    }
                } else {
                    return 0
                }
            },
            setUserInfo() {
                this.apiGet('bbbUserCenterGetUserInfo').then(res => {
                    this.$store.commit('userInfo', {
                        ...res.data,
                    })
                })
            },
            // 设置货币
            setUnit(e) {
                const unitRule = this.$store.state.unitRule
                const value = e || 0
                if (unitRule.ways == 10) {
                    return unitRule.symbol + ' ' + (Math.round(value * 100) / 100).toFixed(unitRule.digit)
                }
                if (unitRule.ways == 20) {
                    return unitRule.symbol + ' ' + Math.floor(value)
                }
                if (unitRule.ways == 30) {
                    return unitRule.symbol + ' ' + Math.ceil(value)
                }
            },
            // 设置库存显示状态
            getStockState(row) {
                // const stockQuantity =
                //     row.skuItemDefault?.stockQuantity != undefined ? row.skuItemDefault.stockQuantity : row.stockQuantity
                // if (stockQuantity > 0 && stockQuantity >= row.safetyStock) {
                //     return '充足'
                // }
                // if (stockQuantity > 0 && stockQuantity < row.safetyStock) {
                //     return '紧张'
                // }
                // return '缺货'
                if (this.$store.state.isLogin) {
                    return row.stockNumLabel
                }
                return '有库存'
            },
            /* 检查数据是否为空的函数。 */
            disEmpty(e) {
                if (e) {
                    if (Array.isArray(e)) {
                        if (e.length) {
                            return true
                        } else {
                            return false
                        }
                    } else if (is.object(e)) {
                        return Object.keys(e).length == 0 ? false : true
                    }
                } else {
                    return false
                }
            },
            /* 检查数据是否为空的函数直接返回。 */
            mixEmpty(e) {
                if (e) {
                    if (Array.isArray(e)) {
                        if (e.length) {
                            return e
                        } else {
                            return []
                        }
                    } else if (e.constructor === Object) {
                        return Object.keys(e).length == 0 ? {} : e
                    }
                } else {
                    return {}
                }
            },
            // 合并对象或者数组不改变原数据的高级数据类型,例如数组和对象如果被改变则无视 比如数组变为Null
            assignEmpty(target = {}, source = {}) {
                if (Array.isArray(source)) {
                    const arr = source.map(item => {
                        return this.assignEmpty(target[0], item)
                    })
                    return arr
                }
                const data = { ...target }
                const defData = { ...target }
                const dataKey = Object.keys(source)
                const defDataKey = Object.keys(defData)
                if (defDataKey.length == 0) {
                    return source
                }
                dataKey.forEach(item => {
                    defDataKey.forEach(ele => {
                        if (item == ele) {
                            if (Array.isArray(defData[ele])) {
                                if (source[item] && source[item].length) {
                                    data[item] = source[item]
                                } else {
                                    data[item] = defData[ele]
                                }
                            } else if (defData[ele] && defData[ele].constructor === Object) {
                                if (source[item] && Object.keys(source[item]).length) {
                                    data[item] = source[item]
                                } else {
                                    data[item] = defData[ele]
                                }
                            } else {
                                data[item] = source[item]
                            }
                        } else if (!defDataKey.includes(item)) {
                            data[item] = source[item]
                        }
                    })
                })
                return data
            },
            /**
             * 重置到默认值
             * @constructor
             * @param {string} e - 重置data数据,不穿则重置全部.
             */
            resetData(e) {
                const data = this.$options.data.call(this)
                if (e) {
                    e.split(',').forEach(item => {
                        this[item] = data[item]
                    })
                } else {
                    Object.assign(this.$data, data)
                }
            },
            // 判断数组是否相等
            isEqual(arr1 = [], arr2 = []) {
                const a = [...arr1]
                const b = [...arr2]
                return JSON.stringify(a.sort()) == JSON.stringify(b.sort())
            },
            /**
             * 获取字典数据
             * @constructor
             * @param {string} dictCode - 重置data数据,不穿则重置全部.
             */ getDict(dictCode, format) {
                return new Promise((resolve, reject) => {
                    this.apiGet('sysDict', {
                        dictCode: dictCode,
                        pageSize: 10000,
                    }).then(res => {
                        if (format) {
                            let arr = []
                            if (res.data.content) {
                                arr = res.data.content.map(item => {
                                    return {
                                        label: itemName,
                                        value: itemCode,
                                    }
                                })
                            } else {
                                arr = res.data.map(item => {
                                    return {
                                        label: itemName,
                                        value: itemCode,
                                    }
                                })
                            }
                            resolve(arr)
                        } else {
                            resolve(res.data.content || res.data)
                        }
                    })
                })
            },
        },
    })
}
